export default __webpack_public_path__ + "static/media/verificationPending.14234c22.svg";